export const getPrecisionRegex = (precision: number): RegExp =>
  precision === 0 ? /^-?\d+$/ : new RegExp(`^-?\\d+(\\.\\d{1,${precision}})?$`);

export const integerRegex = /^\d+$/;
